const content = [
    {
      id: 1,
      title: 'About Me',
      body: 'Experienced professional with a diverse background spanning 10 years in music composition, quality checks, machine maintenance, file work, emergency healthcare, and package shipping. Skilled in collaborating across industries, including entertainment, corrections, mechanics, youth care, recording, and goods shipment. Proficient in JavaScript, HTML, and CSS. Passionate about developing video games and composing original music for these projects.',
      image: 'chill-pic.JPG',
    },
    {
      id: 2,
      title: 'Projects',
      body: `Dive into a world of creativity and innovation through my coding projects. 
      Embark on an immersive journey with (The Choice Within), a captivating story-driven
      video game crafted with HTML, CSS, and JavaScript, where decisions shape destinies. Experience seamless functionality and dynamic interfaces with (Game Finder +), a React app designed to enhance your gaming exploration. And this is just the beginning. Discover a myriad of projects on my GitHub page, where each repository unveils its own unique story of technical mastery and imaginative solutions.`,
      image: 'choice-1.jpg',
      image3: 'game-1.jpg',
      site: ' https://jeromesax.github.io/Story_Game/',
      site2: 'https://game-finderplus.netlify.app',
    },
    {
      id: 3,
      title: 'Music',
      body: "As a multi-instrumentalist with a passion that has spanned 19 years, I've breathed life into melodies with my saxophone and collaborated with diverse talents, producing resonating harmonies. Join me in the symphony of creativity, where I've ventured beyond conventional boundaries. Immerse yourself in the ethereal soundscapes of (Soundbending Vol.1), a joint album that showcases the fusion of art and innovation. Beyond albums, I've delved into the dynamic intersections of music, technology, and video games, curating experiences that transcend genres. From live performances in eclectic venues to features on albums across musical landscapes, my musical journey is one that bridges emotions, genres, and boundaries.",
      image: 'Rev.jpg',
      image3: 'sax1.jpg',
      site: 'https://soundcloud.com/knottyprofessor/reverie-feat-jd',
    },
  ]
  
  export default content